export default function Pagination({ currentPage, totalPages, onPageChange }) {
  if (!totalPages || totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const btn = (active, disabled = false) => ({
    padding: "7px 13px",
    borderRadius: 8,
    border: "1px solid " + (active ? "#f97316" : "#334155"),
    background: active ? "#f97316" : "transparent",
    color: active ? "#fff" : "#94a3b8",
    cursor: disabled ? "not-allowed" : "pointer",
    fontSize: 13,
    fontWeight: active ? 600 : 400,
    opacity: disabled ? 0.4 : 1,
    transition: "all .15s",
  });

  return (
    <div style={{ display:"flex", gap:6, justifyContent:"center", padding:"20px 0 28px", flexWrap:"wrap" }}>
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        style={btn(false, currentPage === 1)}
      >
        ← Prev
      </button>

      {pages.map(p => (
        <button key={p} onClick={() => onPageChange(p)} style={btn(p === currentPage)}>
          {p}
        </button>
      ))}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        style={btn(false, currentPage === totalPages)}
      >
        Next →
      </button>
    </div>
  );
}